<template>
    <div class="not-found">
        <div class="img"></div>
        <div class="right">
            <div class="description">
                Упс, страницы не существует
            </div>
            <h1>
                404
            </h1>
            <div class="description">
                Page not found
            </div>
            <el-button type="warning" @click="$router.push({name: 'home'})">
                на главную
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page404'
};
</script>
